import { http } from '@/plugins/http'

export default class SectorService {
  async destroy(id: string) {
    return await http.delete(`/api/v1/office/sectors/${id}`)
  }
}
